<template>
    <div class="r-p-edc">
        <SOSlotBase :container-name="'r-p-edc-content'">
            <template v-slot:title-bar>
                <SOTitleBar :page-title="'Riwayat Pembayaran EDC'" :type="'back'" @back="back" />
            </template>
            <template v-slot:skeleton v-if="isFetching && !isLoadMore">
                <div class="p-x-20 p-y-16 w-limit">
                    <div class="ph-item m-d-16 p-0" style="margin-bottom: 0px">
                        <div class="ph-col-12 p-y-12 p-x-20">
                            <div class="ph-row m-0 d-flex-between-center">
                                <div class="ph-col-6 big m-0"></div>
                                <div class="ph-col-4 big m-0"></div>
                            </div>
                        </div>
                        <div class="ph-col-12 p-y-12 p-x-20 border-bottom">
                            <div class="ph-row m-0">
                                <div class="ph-col-10 m-d-8"></div>
                                <div class="ph-col-10 m-d-8"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div v-if="totalPembayaranEdc && (isMinExport || !isExporting)">
                    <SOExportProgressMinimized
                        v-if="isMinExport"
                        :processed-data="exportProgress.processed"
                        :total-data="exportProgress.total"
                        :context="'Riwayat Pembayaran EDC'"
                        :tracker-actions="`${modulName}/exportTracker`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                    />
                    <SOExportMultipleFile
                        v-if="isMultipleExport"
                        :export-data="dataExport"
                        :export-data-length="dataLength"
                        :delete-cluster-actions="`${modulName}/exportDeleteCluster`"
                        :delete-master-actions="`${modulName}/exportDeleteMaster`"
                        @downloaded="(index) => { dataExport[index].downloaded = true }"
                        @done="finishExport"
                    />
                </div>
                <div class="p-t-8">
                    <div class="ctn-head f-12 f-regular f-c-midgrey text-center p-y-16 p-x-20">
                        <p class="m-d-4 f-13">{{ detailMesin.nama_mesin_edc }} • {{ detailMesin.nama_outlet }}</p>
                        <p class="m-d-4 f-c-black f-bold f-18">{{ detailMesin.saldo | currency }}</p>
                        <p class="m-d-4" v-if="detailMesin.saldo">Saldo belum di-settlement</p>
                    </div>
                    <div class="tot-head bg-grey p-y-12">
                        <p class="p-x-20 f-16 f-c-midgrey f-regular m-d-0">{{ totalPembayaranEdc }} Pembayaran</p>
                    </div>
                    <div v-if="totalPembayaranEdc" class="p-t-8">
                        <SOCardPembayaranEdc ref="pembayaranEdcCard" />
                    </div>
                    <div v-else class="p-x-20 p-t-16">
                        <label class="m-d-0 f-13 f-c-midgrey f-regular"
                            >Belum ada pembayaran dengan mesin EDC ini sejak terakhir settlement...</label
                        >
                    </div>
                    <SOLoadMoreLoading :id="'load-more-mesin-edc'" :loading="isLoadMore" />
                    <div v-if="!isFetching && !isLoadMore && totalPembayaranEdc">
                        <SOFABExport @export="openModalExport" />
                    </div>
                </div>
            </template>
            <template v-slot:export-import>
                <div class="vh-100" v-if="isExporting && !isMinExport">
                    <SOExportProgress
                        :context="'Riwayat Pembayaran EDC'"
                        :tracker-actions="`${modulName}/exportTracker`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                        @minimized-export="minimizedExport"
                    />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";

import SOCardPembayaranEdc from "../components/SOCardPembayaranEdc.vue";

import { moduleName } from "../store/state";

export default {
    name: "RiwayatPembayaranEdc",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOCardPembayaranEdc,
        SOLoadMoreLoading,
        SOFABExport,
        SOExportProgress,
        SOExportProgressMinimized,
        SOExportMultipleFile,
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === "mesin.edc.detail") {
            this.resetListRiwayatPembayaran();
            this.resetPaginationRiwayatPembayaran();
        }

        next();
    },
    mounted() {
        this.init();
        this.scrollTo();
    },
    computed: {
        ...mapGetters(moduleName, {
            detailMesin: "detailMesin",
            displayCard: "displayCard",
            endPembayaranOfPage: "endPembayaranOfPage",
            totalPembayaranEdc: "totalPembayaranEdc",
            listPembayaranEdc: "listPembayaranEdc",
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            exportData: "exportData",
            exportProgress: "exportProgress",
        }),
        modulName() {
            return moduleName;
        },
        isMinExport() {
            return this.exportData.minimized;
        },
        isExporting() {
            return this.exportData.exporting;
        },
        isMultipleExport() {
            return this.exportData.multiple;
        },
        dataExport() {
            return this.exportData.data;
        },
        dataLength() {
            return this.exportData.dataLength;
        },
    },
    methods: {
        ...mapActions({
            getRiwayatPembayaranEdc: `${moduleName}/getRiwayatPembayaranEdc`,
            getDetailMesin: `${moduleName}/getDetailMesin`,
            resetListRiwayatPembayaran: `${moduleName}/resetListRiwayatPembayaran`,
            resetPaginationRiwayatPembayaran: `${moduleName}/resetPaginationRiwayatPembayaran`,
            setEndPembayaranOfPage: `${moduleName}/setEndPembayaranOfPage`,
            toggleExporting: `${moduleName}/toggleExporting`,
            setMinimized: `${moduleName}/setMinimized`,
            setMultiple: `${moduleName}/setMultiple`,
            exportTracker: `${moduleName}/exportTracker`,
            setData: `${moduleName}/setData`,
            setDataLength: `${moduleName}/setDataLength`,
            setExportProgress: `${moduleName}/setExportProgress`,
        }),
        back() {
            this.$router.push({ name: "mesin.edc.detail" });
        },
        async init() {
            if (!this.listPembayaranEdc.nama_mesin_edc) {
                await this.getDetailMesin(this.$route.params.id_mesin);
            }
            if (this.listPembayaranEdc.length === 0) {
                await this.getRiwayatPembayaranEdc({ idedc: this.$route.params.id_mesin });
            }
        },
        scrollTo() {
            let el = document.getElementById(this.endPembayaranOfPage.id);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        setLastItem() {
            let newDP = this.displayCard.sort(function(a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newDP[0]) {
                this.setEndPembayaranOfPage(newDP[0]);
            }
        },
        openModalExport() {
            this.$router.push({ name: "mesin.edc.detail.riwayat_pembayaran_edc.export" });
        },
        async checkExport() {
            this.toggleExporting(false);
            this.setMinimized(false);
            this.setMultiple(false);

            let tracker = await this.exportTracker();
            if (!tracker.success) {
                return;
            }

            this.setDataLength(tracker.data.length);

            if (tracker.data.info_data_export.length > 0) {
                if (tracker.data.status === 1) {
                    this.setMultiple(true);
                    this.setData(tracker.data.info_data_export);
                    if (this.dataExport.length > 0) {
                        this.dataExport.forEach((v) => {
                            v["downloaded"] = false;
                        });
                    }
                } else {
                    this.setMinimized(true);
                }
            }
        },
        exportFail() {
            this.toggleExporting(false);
        },
        minimizedExport(data) {
            this.setMinimized(true);
            this.setExportProgress(data);
        },
        finishExport() {
            this.setMultiple(false);
            this.setData([]);
        },
    },
};
</script>
